import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NetworkConfig } from 'src/app/models/settings/NetworkConfig';
import { RuntimeConfigService } from 'src/app/services/app/runtime-config.service';
import { NgStyle } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-web-footer',
    templateUrl: './web-footer.component.html',
    styleUrls: ['./web-footer.component.css'],
    imports: [NgStyle, FormsModule, ReactiveFormsModule]
})
export class WebFooterComponent {

  serverIPForm: FormGroup;
  
  displayServerIPForm: string = 'none';

  constructor(private router: Router, public runtimeConfigService: RuntimeConfigService) {} 

  ngOnInit(): void {
    this.serverIPForm = new FormGroup({
      ServerIP: new FormControl(null)
    });
  }

  redirectTo(page){
    this.router.navigate([page]);
  }

  async openServerIPForm() {
    let networkConfig = await this.runtimeConfigService.getStoredLocalApiIp();

    if(networkConfig.ServerIP !== null) {
      this.serverIPForm.controls['ServerIP'].setValue(networkConfig.ServerIP);
    }

    this.displayServerIPForm = 'block';
  }

  saveServerIPForm() {
    let config: NetworkConfig = {
      ServerIP: this.serverIPForm.controls['ServerIP'].value
    };

    this.runtimeConfigService.setLocalApiIp(config);

    this.displayServerIPForm = 'none';
  }

  // closeServerIPForm() {
  //   this.displayServerIPForm = 'none';
  // }
}
